export const defaultOptions = {
    logLevel: 'error',

    marketConsent: {
        enabled: true,
        required: false,
    },
};
